import { render, staticRenderFns } from "./ProjectRawReleaseInfo.vue?vue&type=template&id=37f74e02&scoped=true"
import script from "./ProjectRawReleaseInfo.vue?vue&type=script&lang=js"
export * from "./ProjectRawReleaseInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectRawReleaseInfo.vue?vue&type=style&index=0&id=37f74e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f74e02",
  null
  
)

export default component.exports